import { render } from "./ReaderView.vue?vue&type=template&id=f2e7aafa"
import script from "./ReaderView.vue?vue&type=script&lang=js"
export * from "./ReaderView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__